import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import BackBar from "../home/BackBar";
import { postData } from "../../Service/ApiMethod";
import { baseUrl, CONTACT_US } from "../../Service/service";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "../../common/HeaderAfterLogin";
import Footer from "../../common/Footer";
import { lang } from "../../lang";

function ContectSupport() {
  const { t } = useTranslation();

  const [ln,setLn] = useState('en')
  const [userName, setUserName] = useState();
  const [ticket, setTicket] = useState();
  const [subject, setSubject] = useState();
  const [description, setDescription] = useState();

  const navigate = useNavigate();

  const handleHome = () => {
    navigate("/home");
  };

  useEffect(()=>{
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
  },[])

  const handleClick = () => {
    console.log(userName, ticket, subject, description);
    let token = localStorage.getItem("catzapp_token")
    if(token != null){
    let dataObj = {
      // first_name: "piyush",
      // ticket_type: "Related_to_Coins",
      subject: subject,
      description: description,
    };

    if (!subject) {
      alert("Subject Required");
    } else if (!description) {
      alert("Description is Required");
    } else {
      postData(dataObj, CONTACT_US)
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth[data?.message]:"")
          setTimeout(() => {
            navigate("/home")
          }, 1000)
        })
        .catch((err) => {
          console.log("Error in categories from Post Form", err);
          console.log(" code Error", err);
        });

    }
  }else{
    alert("Please Login First")
    navigate("/login")
  }
  };
  // useEffect(() => {
  //   handleClick();
  // }, []);


  return (
    <>
      <Header />
      <div className="wrapped-content-area pt-3" style={{ }}>
        <BackBar title={t("Contact Support")} onClick={handleHome} />

        <hr className="line m-0 mb-3" />
        <div className="support-outer">
          <div className="row" style={{ justifyContent: "center" }}>
            <div className="col-lg-6 col-md-9 col-md-auto col-sm-10 col-12 right-side-create-subusers mx-5">
              <p className="heading mb-4 mx-3">{t("Contact Support")}</p>
              <div className="row">
                <div className="col-lg-12 col-12">
                  <input
                    type="text"
                    placeholder={t("Enter Subject")}
                    className="input-text mb-2"
                    value={subject}
                    maxLength={20}
                    onChange={(e) => setSubject(e.target.value)}
                  />
                  {/* <input
                  type="text"
                  placeholder="Enter Your Name *"
                  className="input-text mb-2"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                /> */}

                  {/* <input
                  type="text"
                  placeholder="Enter Ticket Type *"
                  className="input-text mb-2"
                  value={ticket}
                  onChange={(e) => setTicket(e.target.value)}
                /> */}

                  <textarea
                    rows="4"
                    cols="7"
                    type="text-area"
                    placeholder={t("Enter description")}
                    className="input-text mb-2"
                    value={description}
                    maxLength={100}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
              </div>
              <div className="flex-center my-3">
                <button className="theme-btn px-5" onClick={(e) => handleClick()}>
                  {t('Submit')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>

  );
}

export default ContectSupport;
